// ***** Third-party CSS *****
import "bootstrap/dist/css/bootstrap.min.css";

import "./src/fonts/uchicago-fonts.css";

// ***** In dependency order *****
import "./src/styles/tokens.css";
import "./src/styles/base.css";
import "./src/styles/layout.css";
import "./src/styles/components.css";
import "./src/styles/utilities.css";

// ***** Unique overrides — component-specific styling *****
import "./src/styles/unique-overrides/navBarMain.css";
import "./src/styles/unique-overrides/navBarMobile-styles.css";
import "./src/styles/unique-overrides/footer.css";
import "./src/styles/unique-overrides/home.css";
import "./src/styles/unique-overrides/studentJourneys.css";
import "./src/styles/unique-overrides/initiatives.css";
import "./src/styles/unique-overrides/employers.css";
import "./src/styles/unique-overrides/founders.css";
import "./src/styles/unique-overrides/support.css";
import "./src/styles/unique-overrides/card-styles.css";

// ***** adding the Poppins font *****
import "@fontsource/poppins/300.css"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"
import "@fontsource/poppins/900.css"

// **** adding the Petrona font *****
import "@fontsource-variable/petrona"
import "@fontsource-variable/petrona/wght-italic.css"

// ***** Scroll-to-anchor for hash links (e.g. /initiatives#stars-initiative-grid) *****
// Gatsby's router doesn't auto-scroll to hash fragments on client-side
// navigation the way a native browser page load does, so we handle it here.
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    if (location.hash) {
        const id = decodeURIComponent(location.hash.replace("#", ""));
        scrollToIdWithRetry(id);
        return false; // we're handling scroll ourselves
    }
    return true; // default scroll-to-top behavior for normal navigation
};

// Retries because the target section may not be in the DOM yet on the
// first frame after navigation (async render, GSAP reveal wrappers, etc).
function scrollToIdWithRetry(id, attempts = 20) {
    const el = document.getElementById(id);
    if (el) {
        const headerOffset = 90; // adjust to match your sticky nav height, or 0 if none
        const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top, behavior: "smooth" });
        return;
    }
    if (attempts > 0) {
        requestAnimationFrame(() => scrollToIdWithRetry(id, attempts - 1));
    }
}